export const REFUND_ENROLLMENT = "REFUND_ENROLLMENT";
export const UPDATE_ENROLLMENT = "UPDATE_ENROLLMENT";
export const CREATE_ENROLLMENT = "CREATE_ENROLLMENT";
export const SEND_ENROLLMENT_INVOICE = "SEND_ENROLLMENT_INVOICE";
